import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReverseInvoiceEffects } from './effects/reverse-invoice.effects';
import { reverseInvoiceFeatureKey, reverseInvoiceReducer } from './reverse-invoice-reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(reverseInvoiceFeatureKey, reverseInvoiceReducer),
        EffectsModule.forFeature([ReverseInvoiceEffects])
    ]
})
export class ReverseInvoiceStoreModule {}
